import type { routes } from '@semios/app-platform-banyan-route-definitions'
import { sumEventDurationsInWindow } from 'App/irrigation-scheduler/components/Grid/components/IrrigationZoneEmitterRows/components/_utils/sumEventDurationsInWindow'
import { sumPulseEventDurations } from 'App/irrigation-scheduler/components/Grid/components/IrrigationZoneEmitterRows/components/_utils/sumPulseEventDurations'
import moment from 'moment-timezone'
import type { TParsedZoneEvents } from '../../_utils/parseZoneEvents'
import { getZoneEvents } from '../../_utils/parseZoneEvents'
import type { TDateRange } from '../../types'
import type { TZoneSummary } from '../types'

export const computeZoneSummaries = (
  eventsResponse: routes.IrrigationSchedulerEventsGet.Response | null,
  dateRange: TDateRange,
  timezone: string,
  parsedEvents: Record<string, TParsedZoneEvents>,
): TZoneSummary[] => {
  if (!eventsResponse?.length) return []

  const viewStart = moment.tz(dateRange.dateFrom, timezone).startOf('day')
  const viewEnd = moment.tz(dateRange.dateTo, timezone).endOf('day')
  const zoneTotals: Record<number, { planned: number; applied: number }> = {}

  eventsResponse.forEach((ze) => {
    const { scheduledEvents, scheduledPulseEvents, appliedEvents } = getZoneEvents(
      parsedEvents,
      ze.irrigationZoneEmitterId,
    )

    zoneTotals[ze.irrigationZoneId] ??= { planned: 0, applied: 0 }

    zoneTotals[ze.irrigationZoneId].planned +=
      sumEventDurationsInWindow(scheduledEvents, viewStart, viewEnd) +
      sumPulseEventDurations(scheduledPulseEvents, viewStart, viewEnd)

    zoneTotals[ze.irrigationZoneId].applied += sumEventDurationsInWindow(appliedEvents, viewStart, viewEnd)
  })

  return Object.entries(zoneTotals).map(([zoneId, totals]) => ({
    zoneId: Number(zoneId),
    plannedMinutes: totals.planned,
    appliedMinutes: totals.applied,
  }))
}
